
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosambhajinagartaxi() {



    const cardData =
    {
        keyword: 'Pune to Sambhaji Nagar Taxi',
        heading: 'Platinum24 Cabs: Pune to Sambhaji Nagar Taxi',
        headingDescription: ' Platinum24 Cabs offers dependable Pune to Sambhaji Nagar Taxi services, ensuring a safe and comfortable ride for business, family, or leisure travel. Our fleet includes hatchbacks, sedans, SUVs, and luxury cars, all well-maintained and air-conditioned for long highway journeys. With professional drivers familiar with the Pune–Sambhaji Nagar route, we guarantee punctual pickups, smooth travel, and convenient stops along the way. Whether you need a one-way drop, round-trip booking, or a multi-day cab hire, Platinum24 Cabs provides transparent fares, 24/7 availability, and a stress-free travel experience every time.',

        top: 'Top Places to Visit in Sambhaji Nagar with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves, a UNESCO World Heritage Site, are world-renowned for their exquisite Buddhist rock-cut caves dating back to the 2nd century BCE. The caves feature stunning murals, paintings, and sculptures depicting Jataka tales. Hidden in a horseshoe-shaped gorge, they are a treasure of ancient Indian art. Monsoon adds greenery and waterfalls, enhancing the experience. Ajanta is Sambhajinagar’s most precious cultural heritage."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, another UNESCO World Heritage Site, house 34 caves representing Buddhism, Hinduism, and Jainism. The Kailasa Temple, carved out of a single rock, is the world’s largest monolithic structure. Intricate carvings and sculptures showcase India’s architectural brilliance. The site reflects harmony among religions. Tourists from across the globe admire its scale and beauty. Ellora is Sambhajinagar’s crown jewel of history and faith."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara, often called the ‘Taj of the Deccan,’ was built by Aurangzeb’s son Azam Shah in memory of his mother. Its Mughal-style architecture closely resembles the Taj Mahal in Agra. The mausoleum is surrounded by lush gardens and fountains. Evening views make it especially picturesque. It is a major tourist attraction in Sambhajinagar. Bibi Ka Maqbara is the city’s romantic and historic landmark."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, perched on a conical hill, is one of India’s strongest forts. It was once the capital under Muhammad-bin-Tughlaq. The fort’s complex includes moats, gates, secret passages, and defense systems. The climb to the top offers panoramic views of the surroundings. History enthusiasts love exploring its architecture and tales of power. Daulatabad is Sambhajinagar’s majestic hill fort of resilience."
  },
  {
    "title": "Grishneshwar Temple",
    "description": "Grishneshwar Jyotirlinga Temple, near Ellora, is one of the 12 Jyotirlingas of Lord Shiva. The temple’s Hemadpanthi architecture features intricate stone carvings. Pilgrims from across India visit for darshan and blessings. Festivals like Mahashivratri are celebrated with great devotion. The temple is surrounded by a spiritual aura and scenic beauty. Grishneshwar is Sambhajinagar’s divine heritage shrine."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki, meaning ‘water mill,’ is a 17th-century engineering marvel built to grind grain for pilgrims. It is powered by water brought through underground channels from a river 6 km away. The site also includes a mosque, gardens, and a reservoir. The serene atmosphere attracts tourists and devotees. It showcases Mughal-era ingenuity in science and architecture. Panchakki is Sambhajinagar’s historic marvel of engineering."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves, located on a hill near the city, are rock-cut Buddhist shrines from the 6th–7th centuries. They feature impressive sculptures of deities and detailed carvings. The caves offer panoramic views of Bibi Ka Maqbara and the city below. Few tourists visit, making it a peaceful heritage site. It is a hidden gem for history lovers and explorers. Aurangabad Caves are Sambhajinagar’s underrated heritage treasure."
  },
  {
    "title": "Salim Ali Lake & Bird Sanctuary",
    "description": "Salim Ali Lake and Bird Sanctuary is a green haven within Sambhajinagar, named after the famous ornithologist. It is home to migratory birds, making it a favorite for birdwatchers and photographers. The lake was originally part of a Mughal-era water system. Walking trails and boating facilities add charm. It is a peaceful spot away from city chaos. Salim Ali Lake is Sambhajinagar’s natural retreat of serenity."
  },
  {
    "title": "Chand Minar",
    "description": "Chand Minar, located inside Daulatabad Fort, is a striking 30-meter-high tower built in 1435. Modeled after the Qutub Minar, it was constructed by Ala-ud-din Bahmani to commemorate his victory. The tower features Persian-style architecture with intricate designs. Though entry inside is restricted, it remains a prominent landmark. Visitors admire its beauty against the fort backdrop. Chand Minar is Sambhajinagar’s symbol of Islamic art and victory."
  },
  {
    "title": "Soneri Mahal",
    "description": "Soneri Mahal, meaning ‘Golden Palace,’ is a 17th-century palace located near the Aurangabad Caves. Built by a Bundelkhand chief, it has beautiful paintings, frescoes, and a museum showcasing local heritage. The palace hosts cultural festivals and dance programs. Its gardens and historic aura make it picturesque. It is a reminder of Sambhajinagar’s royal past. Soneri Mahal is the city’s cultural palace of heritage."
  }
],



  "services": [
    {
      "name": "Pune to Sambhaji Nagar Cab",
      "description": "Comfortable and reliable cab service from Pune to Sambhaji Nagar, ideal for long-distance travelers seeking a stress-free ride. Our fleet includes hatchbacks, sedans, and SUVs to suit solo riders, families, and corporate groups. Enjoy clean, well-maintained vehicles driven by courteous chauffeurs who ensure safety and punctuality. Whether you're traveling for business or leisure, our Pune to Sambhaji Nagar cabs offer a convenient and affordable option with door-to-door service."
    },
    {
      "name": "Taxi from Pune to Sambhaji Nagar",
      "description": "Book a taxi from Pune to Sambhaji Nagar with ease and flexibility. Choose from multiple vehicle types, including AC sedans, spacious SUVs, and economy cars. Our drivers are professionally trained and familiar with the route, ensuring a smooth and timely journey. We offer 24/7 customer support, transparent pricing, and GPS-enabled taxis so you can travel with complete confidence and peace of mind."
    },
    {
      "name": "Sambhaji Nagar Taxi Service",
      "description": "Explore Sambhaji Nagar with our local and outstation taxi services that cater to all travel needs—whether it’s a short city trip or an extended tour. Our taxis are equipped with air conditioning, clean interiors, and professional drivers. Services include hourly rentals, full-day bookings, and custom tour packages. Perfect for sightseeing, business meetings, and local transfers within Sambhaji Nagar and nearby areas."
    },
    {
      "name": "Pune to Sambhaji Nagar Car Rental",
      "description": "Affordable car rental service from Pune to Sambhaji Nagar with options for self-drive or chauffeur-driven vehicles. Choose from a wide range of cars, including compact, mid-size, and premium models to suit your travel style and budget. Our rental plans are flexible, with hourly, daily, and multi-day packages that include fuel, tolls, and driver allowance where applicable. Ideal for individuals, families, and corporate clients."
    },
    {
      "name": "Cab Booking Pune to Sambhaji Nagar",
      "description": "Quick and easy cab booking for your Pune to Sambhaji Nagar trip with instant confirmation and flexible pickup options. Book online or by phone, and choose from a range of vehicles, including AC hatchbacks, luxury sedans, and 7-seater SUVs. Our booking system ensures a seamless process, with transparent fares and 24/7 customer support. Book in advance or on-demand for a reliable ride."
    },
    {
      "name": "Pune to Sambhaji Nagar Taxi Fare",
      "description": "Get detailed and transparent taxi fare estimates for Pune to Sambhaji Nagar trips. Fare is calculated based on distance, vehicle type, travel time, and whether it’s a one-way or round trip. No hidden charges—our pricing includes fuel, driver allowance, tolls, and applicable taxes. Compare rates across different car categories and choose the best option for your journey."
    },
    {
      "name": "Sambhaji Nagar Private Taxi",
      "description": "Hire a private taxi in Sambhaji Nagar for personalized travel experiences. Whether you need a full-day city tour, a drop to the airport, or an outstation ride, our private taxis are available at competitive rates. Enjoy the comfort of a sanitized vehicle with a professional driver and travel as per your schedule, with full privacy and zero wait time."
    },
    {
      "name": "Pune Sambhaji Nagar Taxi Booking",
      "description": "Book your taxi from Pune to Sambhaji Nagar in just a few clicks. Our platform offers real-time availability, competitive pricing, and verified drivers. Enjoy smooth rides in well-maintained cabs with on-time pickups, safety assurance, and customer-first support throughout your journey. Perfect for urgent travel, planned trips, or business commuting."
    },
    {
      "name": "Affordable Taxi Pune to Sambhaji Nagar",
      "description": "Get the best value taxi service from Pune to Sambhaji Nagar with affordable rates and quality service. We offer discounts on round trips, long-distance bookings, and early reservations. All taxis are GPS-enabled and sanitized before every ride. No surge pricing or hidden charges—just straightforward, budget-friendly transportation with professional drivers."
    },
    {
      "name": "Taxi Service from Pune to Sambhaji Nagar",
      "description": "Premium taxi service operating between Pune and Sambhaji Nagar, with well-trained drivers, safe vehicles, and full support throughout your journey. Ideal for daily commuters, tourists, and corporate clients. We provide scheduled and on-demand pickups, luggage assistance, and custom travel plans to suit your exact needs."
    },
    {
      "name": "Pune to Sambhaji Nagar One Way Cab",
      "description": "Book a one-way cab from Pune to Sambhaji Nagar and pay only for the distance you travel. No return fare, no hidden fees—just clean vehicles, reliable drivers, and timely service. One-way cabs are perfect for solo or group travelers seeking cost-effective transportation without compromising on comfort or safety."
    },
    {
      "name": "Sambhaji Nagar Taxi Packages Pune",
      "description": "Choose from a range of customized taxi packages for travel between Pune and Sambhaji Nagar. Packages include fuel, tolls, driver allowance, and optional sightseeing stops. Ideal for weekend getaways, family tours, and business travel. We offer both economy and premium vehicles with transparent pricing and flexible scheduling."
    },
    {
      "name": "Sambhaji Nagar Taxi for Local Travel Pune",
      "description": "Hire taxis in Sambhaji Nagar for local city travel from Pune. Services include hourly rentals, business meeting drops, shopping trips, and local sightseeing. Our taxis come with AC, trained drivers, and flexible billing plans. Book by the hour or day, depending on your itinerary and budget."
    },
    {
      "name": "Pune Sambhaji Nagar Outstation Taxi",
      "description": "Book outstation taxis from Pune to Sambhaji Nagar for short or long trips. Our outstation cabs come with route planning, rest stops, and optional return bookings. Perfect for group travel, pilgrimage tours, or personal visits. Choose from a fleet of hatchbacks, sedans, SUVs, and tempo travellers for maximum comfort."
    },
    {
      "name": "Sambhaji Nagar Taxi Rental Pune",
      "description": "Flexible taxi rental service in Sambhaji Nagar from Pune, suitable for personal, business, and event-based travel. Rentals are available with or without a driver and include fuel options, round-the-clock support, and full vehicle sanitization. Book for a few hours, a full day, or an extended period based on your needs."
    }
  ],
  "tableData": [
    ["Pune to Sambhaji Nagar Cab", "Taxi from Pune to Sambhaji Nagar"],
    ["Sambhaji Nagar Taxi Service", "Pune to Sambhaji Nagar Car Rental"],
    ["Cab Booking Pune to Sambhaji Nagar", "Pune to Sambhaji Nagar Taxi Fare"],
    ["Sambhaji Nagar Private Taxi", "Pune Sambhaji Nagar Taxi Booking"],
    ["Affordable Taxi Pune to Sambhaji Nagar", "Taxi Service from Pune to Sambhaji Nagar"],
    ["Pune to Sambhaji Nagar One Way Cab", "Sambhaji Nagar Taxi Packages Pune"],
    ["Sambhaji Nagar Taxi for Local Travel Pune", "Pune Sambhaji Nagar Outstation Taxi"],
    ["Sambhaji Nagar Taxi Rental Pune", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Sambhaji Nagar Taxi Service",
      "WhyChoosedescription": "Platinum24 Cabs provides dependable and comfortable taxi services from Pune to Sambhaji Nagar."
    },
    {
      "WhyChooseheading": "On-Time Pickups for a Stress-Free Journey",
      "WhyChoosedescription": "Our drivers ensure timely pickups so you can reach Sambhaji Nagar without any delays."
    },
    {
      "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel in spacious, clean, and air-conditioned cabs that guarantee a smooth ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Sambhaji Nagar Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes for a safe and efficient journey."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront, all-inclusive pricing covering fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose packages that fit your travel itinerary between Pune and Sambhaji Nagar."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Bookings",
      "WhyChoosedescription": "Our team is available round the clock to assist with your taxi bookings and queries."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, or SUVs depending on your group size and luggage."
    }
  ]























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide taxi services from Pune to Sambhaji Nagar?',
        answer: 'Yes, Platinum24 Cabs offers reliable taxi services for travel between Pune and Sambhaji Nagar.',
    },
    {
        question: 'How can I book a taxi from Pune to Sambhaji Nagar with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Sambhaji Nagar taxi through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Sambhaji Nagar trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Sambhaji Nagar?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Sambhaji Nagar route.',
    },
    {
        question: 'Can I book a round trip taxi from Pune to Sambhaji Nagar?',
        answer: 'Absolutely! We provide round-trip taxi services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Sambhaji Nagar taxi services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Sambhaji Nagar rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Sambhaji Nagar route.',
    },
    {
        question: 'Are safety measures in place for Pune to Sambhaji Nagar taxi rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a taxi for multiple days for Pune to Sambhaji Nagar travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Sambhaji Nagar?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Sambhaji Nagar routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ganesh Kulkarni',
        feedback: 'The Pune to Sambhaji Nagar taxi service by Platinum24 Cabs was punctual and comfortable. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meera Jadhav',
        feedback: 'Booking a taxi from Pune to Sambhaji Nagar was seamless with Platinum24 Cabs. The driver was professional and courteous.',
        rating: 5,
    },
];




































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToSambhajiNagarTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Sambhaji Nagar Taxi",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-sambhaji-nagar-taxi.jpg",
  "description": "Book reliable Pune to Sambhaji Nagar taxi service with affordable fares, private cabs, and local travel options. Platinum24 Cabs offers easy cab booking and verified drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "950",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-sambhaji-nagar-taxi"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Sambhaji Nagar Taxi | Affordable Cab Service | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable Pune to Sambhaji Nagar taxi service with affordable fares, private cabs, and local travel options. Platinum24 Cabs offers easy cab booking and verified drivers."
  />
  <meta
    name="keywords"
    content="Pune to Sambhaji Nagar Cab, Taxi from Pune to Sambhaji Nagar, Sambhaji Nagar Taxi Service, Pune to Sambhaji Nagar Car Rental, Cab Booking Pune to Sambhaji Nagar, Pune to Sambhaji Nagar Taxi Fare, Sambhaji Nagar Private Taxi, Pune Sambhaji Nagar Taxi Booking, Affordable Taxi Pune to Sambhaji Nagar, Taxi Service from Pune to Sambhaji Nagar, Pune to Sambhaji Nagar One Way Cab, Sambhaji Nagar Taxi Packages Pune, Sambhaji Nagar Taxi for Local Travel Pune, Pune Sambhaji Nagar Outstation Taxi, Sambhaji Nagar Taxi Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToSambhajiNagarTaxiSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/24.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosambhajinagartaxi;